import useScrollTrigger from '@mui/material/useScrollTrigger'
import Zoom from '@mui/material/Zoom'
import React from 'react'

function ScrollTop(props) {
    const {children, window} = props
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    })

    const handleClick = event => {
        const anchor = (event.target.ownerDocument || document).querySelector('#scroll-to-top')

        if (anchor) {
            anchor.scrollIntoView({behavior: 'smooth', block: 'center'})
        }
    }

    return (
        <Zoom in={trigger}>
            <div onClick={handleClick} role='presentation' className='scrolltotop'>
                {children}
            </div>
        </Zoom>
    )
}

export default ScrollTop
